import React from 'react';
import { motion } from 'framer-motion';

export const AnimatedLogo = () => {
  const wordVariants = {
    initial: { x: 0, scale: 1 },
    animate: {
      x: 0,
      scale: [1, 1.01, 0.99, 1],
      transition: {
        duration: 4,
        repeat: Infinity,
        repeatDelay: 2,
        ease: "easeInOut"
      }
    }
  };

  const containerVariants = {
    initial: { gap: "3rem" },
    animate: {
      gap: "1.5rem",
      transition: {
        duration: 3,
        delay: 1,
        ease: "easeInOut",
        repeat: Infinity,
        repeatDelay: 3
      }
    }
  };

  return (
    <motion.div
      className="relative flex items-center justify-center animated-logo"
      variants={containerVariants}
      initial="initial"
      animate="animate"
    >
      <div className="relative">
        <motion.div
          variants={wordVariants}
          className="text-3xl font-bold bg-gradient-to-r from-emerald-400 to-emerald-600 bg-clip-text text-transparent"
        >
          Buddy
        </motion.div>
      </div>

      <div className="relative">
        <motion.div
          variants={wordVariants}
          className="text-3xl font-bold bg-gradient-to-r from-emerald-500 to-emerald-700 bg-clip-text text-transparent"
        >
          Budgets
        </motion.div>
      </div>

      <motion.div
        className="absolute inset-0 bg-gradient-to-r from-emerald-500/10 to-emerald-600/10 blur-xl pointer-events-none"
        animate={{
          scale: [1, 1.05, 1],
          opacity: [0.2, 0.3, 0.2],
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          repeatType: "reverse",
          ease: "easeInOut"
        }}
      />
    </motion.div>
  );
};